import {catchError, map} from 'rxjs/operators';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable()
export class LoginService {
    headers: any;

    constructor(private http: HttpClient) {
    }

    logIn(url: string, param: any): Observable<any> {
        let body = param;
        return this.http
            .post(url, body,
                {headers: {'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9'}}).pipe(
                catchError(this.handleError));
    }

    getDetailsByMemberId(url: string): Observable<any> {
        return this.http
            .get(url).pipe(
                catchError(this.handleError));
    }

    postData(url: string, body: any): Observable<any> {
        return this.http
            .post(url, body,
                {headers: {'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9'}}).pipe(
                catchError(this.handleError));
    }

    private handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg);
        return observableThrowError(errMsg);
    }

    getFormUrlEncoded(toConvert) {
        const formBody = [];
        for (const property of Object.keys(toConvert)) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(toConvert[property]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
        return formBody.join('&');
    }
}
